import HomePage from "./components/consent";
import ConsentDeleted from "./components/consent_deleted";

export default [
  {
    path: "/",
    exact: true,
    component: HomePage, // Add your route here
    loadData: () => {},
  },
  {
    path: "/deleted",
    exact: true,
    component: ConsentDeleted, // Add your route here
    loadData: () => {},
  },
];
